import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { modifiersGetAllGroupsForMenu } from "~/api-refs";
import { ModifierGrid } from "~/components/menus/modifier-grid";
import { LoadingPanel } from "~/components/shared/loading-panel";
import { toConvexTableId } from "~/lib/convex-table-id";

export const Route = createFileRoute(
  "/_authenticated/menus/$menuId/modifiers/"
)({
  component: ModifiersListPage,
});

function ModifiersListPage() {
  const { menuId } = Route.useParams();

  const { data: modifierGroups, isPending } = useQuery(
    convexQuery(modifiersGetAllGroupsForMenu, {
      menuId: toConvexTableId("menus", menuId),
    })
  );

  if (isPending || !modifierGroups) {
    return <LoadingPanel message="Loading modifiers..." />;
  }

  return <ModifierGrid menuId={menuId} modifierGroups={modifierGroups} />;
}
